import { module } from 'stereomodularjs';
import BilleterieDate from './BilleterieDate.js';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.dates = JSON.parse(this.el.dataset.dates);
        this.select = this.el.querySelector('.js-select-dates');
        this.customOptions = this.el.querySelector('.js-custom-select-options');
        this.hour = this.el.querySelector('.js-hour');
        this.link = this.el.querySelector('.js-link');
        this.linkMembres = this.el.querySelector('.js-link-membres');
        this.salle = this.el.querySelector('.js-salle');
        this.salleLink = this.el.querySelector('.js-salle-link');
        this.updateSelect = true;

        if (window.billeterie === undefined) {
            window.billeterie = [];
        }
        window.billeterie.push(this);
        this.index = window.billeterie.length - 1;

        this.dates.forEach((date, index) => {
            // date.date format yyyymmdd
            // add option to select
            const dateObj = new Date(date.date.slice(0, 4), date.date.slice(4, 6) - 1, date.date.slice(6, 8));
            const option = document.createElement('option');
            option.value = index;
            option.innerHTML = dateObj.getDate() + ' ' + dateObj.toLocaleString('fr-CA', { month: 'long' });
            this.select.appendChild(option);

            if (this.customOptions) {
                const option = document.createElement('div');
                option.dataset.value = index;
                option.classList.add('o-custom-select__option');
                option.innerHTML = `<span><strong>${dateObj.getDate()}</strong> ${dateObj.toLocaleString('fr-CA', { month: 'long' })}</span>`;
                this.customOptions.querySelector('.js-options').appendChild(option);

                if (this.customOptions.querySelector('.js-label') && this.customOptions.querySelector('.js-label').innerHTML === '') {
                    this.customOptions.querySelector('.js-label').innerHTML = `<span><strong>${dateObj.getDate()}</strong> ${dateObj.toLocaleString('fr-CA', { month: 'long' })}</span>`;
                }
                option.addEventListener('click', (e) => {
                    this.onOptionClick(option);
                });
            }

            if (index === 0) {
                if (this.hour && date.heure) {
                    const hour = date.heure.split(':');
                    this.hour.innerHTML = `<strong>${hour[0]}</strong>`;
                    if (hour[1] && hour[1] !== '00') {
                        this.hour.innerHTML += `h <strong>${hour[1]}</strong>`;
                    }
                    if (hour[1] === '00') {
                        this.hour.innerHTML += 'h';
                    }
                }

                if (this.link instanceof HTMLAnchorElement) {
                    this.link.href = date.url_vente;
                    this.link.target = '_blank';
                } else if (this.link) {
                    this.link.querySelector('a').href = date.url_vente;
                    this.link.querySelector('a').target = '_blank';
                }

                if (this.linkMembres && date.url_prevente) {
                    if (this.linkMembres instanceof HTMLAnchorElement) {
                        this.linkMembres.href = date.url_prevente;
                        this.linkMembres.target = '_blank';
                    } else {
                        this.linkMembres.querySelector('a').href = date.url_prevente;
                        this.linkMembres.querySelector('a').target = '_blank';
                    }
                }

                if (this.salleLink) {
                    this.salle.innerHTML = date.salle;
                    if (this.salleLink instanceof HTMLAnchorElement) {
                        this.salleLink.href = date.salle_url;
                    } else if (this.salleLink) {
                        this.salleLink.querySelector('a').href = date.salle_url;
                    }
                }
            }
        });

        this.select.addEventListener('change', (e) => {
            this.onRealSelectChange(e);
        });
    }

    onOptionClick(option) {
        const value = option.getAttribute('data-value');
        this.customOptions.querySelector('.js-label').innerHTML = option.innerHTML;
        this.select.querySelector(`option[value="${value}"]`).selected = true;
        this.select.dispatchEvent(new Event('change'));
        this.select.classList.add('is-changed');
        setTimeout(() => {
            this.select.classList.remove('is-changed');
        }, 2000);
    }

    onRealSelectChange(e) {
        const shouldPropagate = this.updateSelect;
        this.updateSelect = true;
        const date = this.dates[e.target.value];
        if (date) {
            if (this.hour) {
                const hour = date.heure.split(':');
                this.hour.innerHTML = `<strong>${hour[0]}</strong>h`;
                if (hour[1] !== '00') {
                    this.hour.innerHTML += ` <strong>${hour[1]}</strong>`;
                }
            }

            if (this.link instanceof HTMLAnchorElement) {
                this.link.href = date.url_vente;
            } else if (this.link) {
                this.link.querySelector('a').href = date.url_vente;
            }

            if (this.linkMembres && date.url_prevente) {
                if (this.linkMembres instanceof HTMLAnchorElement) {
                    this.linkMembres.href = date.url_prevente;
                    this.linkMembres.target = '_blank';
                } else {
                    this.linkMembres.querySelector('a').href = date.url_prevente;
                    this.linkMembres.querySelector('a').target = '_blank';
                }
            }

            if (this.salleLink) {
                this.salle.innerHTML = date.salle;
                if (this.salleLink instanceof HTMLAnchorElement) {
                    this.salleLink.href = date.salle_url;
                } else if (this.salleLink) {
                    this.salleLink.querySelector('a').href = date.salle_url;
                }
            }
        }
        const selectedValue = this.select.value;
        this.customOptions.querySelectorAll('.o-custom-select__option').forEach((option) => {
            if (option.getAttribute('data-value') === selectedValue) {
                this.customOptions.querySelector('.js-label').innerHTML = option.innerHTML;

                if (window.billeterie) {
                    window.billeterie.forEach((billeterie) => {
                        // instance of this module
                        if (billeterie instanceof this.constructor && billeterie.index !== this.index && shouldPropagate) {
                            billeterie.switchDate(selectedValue, false);
                        }
                    });
                }
                if (window.billeterieDate) {
                    window.billeterieDate.forEach((billeterieDate) => {
                        // instance of this module
                        if (billeterieDate instanceof BilleterieDate) {
                            billeterieDate.optionClick(selectedValue, false);
                        }
                    });
                }
            }
        });
    }

    switchDate(index, updateSelect = true) {
        if (!updateSelect) {
            this.updateSelect = false;
        }
        this.select.querySelector(`option[value="${index}"]`).selected = true;
        this.select.dispatchEvent(new Event('change'));
        this.select.classList.add('is-changed');
        setTimeout(() => {
            this.select.classList.remove('is-changed');
        }, 2000);
    }
}
